import React from 'react';
import {Flex, Title, Text, Link} from '@priority-software/priority-style-react';
import {MessageDetails, getHardcodedText, DialogText, supportUrl} from './consts';
import styles from './AccountsDialog.module.scss';
import {isRTL} from '../../Localization';
import {getLoginEmail} from '../../_shared/GWTBridge/invoke/common';
import {getIntlDateTimeFormat, getGMTtime, getGMTdiff} from '../../Localization/date';

type Props = {
    details: MessageDetails;
};

const getTime = (hour: string) => {
    const isRtl = isRTL();
    if (isRtl) {
        return hour + ',';
    } else {
        const gmtDiff = getGMTdiff();
        const gmtHour = getGMTtime(hour, gmtDiff);
        return gmtHour;
    }
};

export const DialogContent = ({details}: Props) => {
    const {MovingDay, hour} = details;
    const isRtl = isRTL();
    const time = getTime(hour);
    const loginEmail = getLoginEmail();
    const url = supportUrl + getHardcodedText(DialogText.linkSuffix);

    const onLinkClick = () => {
        window.open(url, '_blank');
    };

    return (
        <Flex direction="column" alignItems="flex-start" componentClasses={styles.contentWrapper}>
            <Title
                skin="h3"
                textColor="primary-700"
                componentClasses={styles.title}
                text={getHardcodedText(DialogText.title)}
            />
            <Text textColor="primary-700">
                <Flex
                    direction="column"
                    alignItems="flex-start"
                    componentClasses={styles.dialogContentText}
                >
                    <Text componentClasses={styles.movingTime}>
                        {isRtl ? 'החל מ' : 'Starting'}
                        <Text tag="span" fontWeight="bold">
                            {getIntlDateTimeFormat(MovingDay)}
                        </Text>
                        <Text tag="span">{isRtl ? 'בשעה' : 'at'}</Text>
                        <Text tag="span" fontWeight="bold">
                            {time}
                        </Text>
                        {!isRtl && <Text tag="span">{'GMT,'}</Text>}
                        <Text tag="span">{getHardcodedText(DialogText.intro)}</Text>
                    </Text>
                    {loginEmail ? (
                        <Flex justifyContent="flex-start" componentClasses={styles.textGap}>
                            <Text>{getHardcodedText(DialogText.loginEmail)}</Text>
                            <Text textColor="primary-500">{loginEmail}</Text>
                        </Flex>
                    ) : (
                        <Text>{getHardcodedText(DialogText.emailMissing)}</Text>
                    )}
                    <Text>{getHardcodedText(DialogText.updateEmail)}</Text>
                    <Flex justifyContent="flex-start" componentClasses={styles.textGap}>
                        <Text>{getHardcodedText(DialogText.watchVideo)}</Text>
                        <Link onClick={onLinkClick} textSize={'large'}>
                            {getHardcodedText(DialogText.linkText)}
                        </Link>
                    </Flex>
                </Flex>
            </Text>
        </Flex>
    );
};
